import React from 'react';
import { Container, Typography, Paper, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import SEO from '../components/SEO';
import { getBreadcrumbSchema } from '../components/StructuredData';

const PrivacyPolicy: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Container maxWidth="lg" sx={{ py: 8 }}>
      <SEO
        title={t('seo.privacyPolicy.title')}
        description={t('seo.privacyPolicy.description')}
        canonicalPath="/privacy-policy"
        jsonLd={[
          getBreadcrumbSchema([
            { name: 'Home', url: '/' },
            { name: t('privacyPolicy.title'), url: '/privacy-policy' },
          ]),
        ]}
      />

      <Paper elevation={2} sx={{ p: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          {t('privacyPolicy.title')}
        </Typography>
        
        <Box sx={{ mt: 4 }}>
          <Typography variant="h5" component="h2" gutterBottom>
            {t('privacyPolicy.introTitle')}
          </Typography>
          <Typography paragraph>
            {t('privacyPolicy.introText')}
          </Typography>
          
          <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
            {t('privacyPolicy.dataCollectionTitle')}
          </Typography>
          <Typography paragraph>
            {t('privacyPolicy.dataCollectionText')}
          </Typography>
          
          <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
            {t('privacyPolicy.dataUseTitle')}
          </Typography>
          <Typography paragraph>
            {t('privacyPolicy.dataUseText')}
          </Typography>
          
          <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
            {t('privacyPolicy.dataSharingTitle')}
          </Typography>
          <Typography paragraph>
            {t('privacyPolicy.dataSharingText')}
          </Typography>
          
          <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
            {t('privacyPolicy.rightsTitle')}
          </Typography>
          <Typography paragraph>
            {t('privacyPolicy.rightsText')}
          </Typography>
          
          <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
            {t('privacyPolicy.contactTitle')}
          </Typography>
          <Typography paragraph>
            {t('privacyPolicy.contactText')}
          </Typography>
          
          <Typography variant="body2" color="text.secondary" sx={{ mt: 4 }}>
            {t('privacyPolicy.lastUpdated')}: 2023-11-01
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
};

export default PrivacyPolicy;
